import { asyncLoadRouter } from '@router/helper'

const reports = [
  {
    path: 'reports',
    component: asyncLoadRouter('manager/machines/Reports'),
    meta: {
      breadcrumb: (i18n) => [
        {
          text: i18n.t('activerecord.models.machine/report.other'),
          to: { name: 'manager-machines-reports' },
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'manager-machines-reports',
        component: asyncLoadRouter('manager/machines/reports/List'),
        meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.list') }] },
      },
    ],
  },
]

export default reports
